import React, { Component } from 'react'
import update from 'immutability-helper'
import {Modal, Button, Form} from 'semantic-ui-react'
import _ from 'lodash'
import FormErrorMessage from "./FormErrorMessage";
// import { bindActionCreators} from 'redux'
// import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {api} from '../../api'
import Dls from '../../lib'

class EmailModal extends Component {
    constructor() {
        super();
        this.state = {
            email: {
                id: '',
                uid: null,
                to_address: '',
                cc_addresses: '',
                name: '',
                type: '',
                doc: '',
                subject: '',
                body: ''
            },
            loading: false,
            errors: [

            ]
        }
    }

    componentDidMount() {
        this.setPropsToStateEmail(this.props);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.uid !== prevState.email.uid) {
            this.setPropsToStateEmail(this.props);
        }
    }
    
    setPropsToStateEmail = ({uid,orderType,id,doc,to_address,contact}) => {
        let subject = '';
        let body = '';
        if (orderType === 'Customer Order') {
            if (doc === 'Order') {
                subject = 'Your order confirmation';
                body = 'We have received your order. Please see attached for your order confirmation.';
            }
            if (doc === 'Shipment') {
                subject = 'Your order has been shipped';
                body = 'We have shipped your order. Please see attached for detail.';
            }
        }
        if (orderType === 'Vendor Order') {
            if (doc === 'Order') {
                subject = 'New purchase order from Direct Line Supplies';
                body = 'Please see attached for our new purchase order.';
            }
            if (doc === 'Shipment') {
                subject = 'Your order has been received';
                body = 'We have received your order. Please see attached for detail.';
            }
        }
        if (orderType === 'Customer Return') {
            if (doc === 'Order') {
                subject = 'Your order return to Direct Line Supplies';
                body = 'Your return has been issued. Please see attached for detail.';
            }
            if (doc === 'Shipment') {
                subject = 'Your return has been received';
                body = 'We have received your return. Please see attached for detail.';
            }
        }
        if (orderType === 'Vendor Return') {
            if (doc === 'Order') {
                subject = 'Request to return products';
                body = 'Please see attached for our return to vendor request.';
            }
            if (doc === 'Shipment') {
                subject = 'Return has been sent back to you';
                body = 'We have shipped our return back to you. Please see attached for detail.';
            }
        }
        this.setState({
            email: {
                id: id,
                uid: uid,
                to_address: to_address,
                cc_addresses: '',
                name: contact,
                type: orderType,
                doc: doc,
                subject: subject,
                body: body
            }
        });
    }

    onUpdateEmailFields = (name, value) => {
        this.setState({
            email: update(this.state.email, {
                [name]: {$set: value}
            })
        })
    } 

    sendMail = () => {
        this.setState({
            loading: true
        });
        api.email.send(this.props.jwt, this.state.email.id, this.state.email).then(res => {
            this.setState({
                loading: false
            });
            Dls.success("Email sent.");
            this.props.onModalClose();
        }).catch(err => {
            const errors = Dls.apiErrorMessage(err);
            this.setState({
                loading: false,
                errors: errors
            });
        });
    }

    render() {
        const {email} = this.state;
        return (
            <Modal size='tiny' open={this.props.show} onClose={this.props.onModalClose} closeOnDimmerClick={false}>
                <Modal.Header>Email</Modal.Header>
                <Modal.Content>
                    {!_.isEmpty(this.state.errors) ? (
                        <FormErrorMessage errors={this.state.errors} />
                    ) : null}
                    <Form size="mini">
                        <Form.Input 
                            size='tiny'
                            fluid 
                            label="Contact Name"
                            name="name"
                            value={email.name} 
                            onChange={(e) => { this.onUpdateEmailFields(e.target.name, e.target.value) }}
                        />
                        <Form.Input 
                            size='tiny'
                            fluid 
                            label="Contact Email"
                            name="to_address"
                            value={email.to_address} 
                            onChange={(e) => { this.onUpdateEmailFields(e.target.name, e.target.value) }}
                        />
                        <Form.Input 
                            size='tiny'
                            fluid 
                            label="CC (Separate by comma)"
                            name="cc_addresses"
                            value={email.cc_addresses} 
                            onChange={(e) => { this.onUpdateEmailFields(e.target.name, e.target.value) }}
                        />
                        <Form.Input 
                            size='tiny'
                            fluid 
                            label="Subject"
                            name="subject"
                            value={email.subject} 
                            onChange={(e) => { this.onUpdateEmailFields(e.target.name, e.target.value) }}
                        />
                        <Form.TextArea 
                            value={email.body}
                            name="body"
                            rows={5}
                            onChange={(e) => { this.onUpdateEmailFields(e.target.name, e.target.value) }}
                        />
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button negative onClick={() => {this.props.onModalClose()}}>Close</Button>
                    <Button positive disabled={this.state.loading} onClick={() => {this.sendMail()}}icon='checkmark' 
                        labelPosition='right' content='Send' />
                </Modal.Actions>
            </Modal>
        )
    }
}
 EmailModal.propTypes = {
     jwt: PropTypes.string.isRequired,
     uid: PropTypes.string.isRequired,
     orderType: PropTypes.string.isRequired,
     id: PropTypes.number.isRequired,
     doc: PropTypes.string.isRequired,
     to_address: PropTypes.string,
     contact: PropTypes.string,
     show: PropTypes.bool.isRequired,
     onModalClose: PropTypes.func.isRequired
};

// function mapStateToProps(state) {
//     return {
//     }
// }

// function mapDispatchToProps(dispatch) {
//     return bindActionCreators({}, dispatch)
// }

//export default connect(mapStateToProps, mapDispatchToProps) (EmailModal)
export default EmailModal


// WEBPACK FOOTER //
// ./src/components/utils/EmailModal.js